// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Form__Core from "./Form__Core.res.js";
import * as Form__Elements__Inputs from "./Form__Elements__Inputs.res.js";
import * as Form__Elements__Buttons from "./Form__Elements__Buttons.res.js";
import * as Form__Elements__Accessibility from "./Form__Elements__Accessibility.res.js";

function Make(FormLenses) {
  let Core = Form__Core.Make(FormLenses);
  let include = Form__Elements__Inputs.Make({
    useField: Core.useField
  });
  let include$1 = Form__Elements__Buttons.Make({
    useSubmit: Core.useSubmit,
    useCancel: Core.useCancel
  });
  let include$2 = Form__Elements__Accessibility.Make({
    useFormValues: Core.useFormValues,
    useFormStatus: Core.useFormStatus,
    useSubmit: Core.useSubmit
  });
  let validate = Core.Schema.validate;
  let isValidField = Core.Schema.isValidField;
  return {
    Core: Core,
    Schema: undefined,
    FormLegacyProvider: undefined,
    FormProvider: undefined,
    InputText: include.InputText,
    InputSuggestionComboBox: include.InputSuggestionComboBox,
    InputSelect: include.InputSelect,
    InputToggleButtonGroup: include.InputToggleButtonGroup,
    InputCountrySelect: include.InputCountrySelect,
    InputTextArea: include.InputTextArea,
    InputPassword: include.InputPassword,
    InputNumber: include.InputNumber,
    InputOptionalNumber: include.InputOptionalNumber,
    InputRadioGroup: include.InputRadioGroup,
    InputRadioCardGroup: include.InputRadioCardGroup,
    InputPhone: include.InputPhone,
    InputCheckbox: include.InputCheckbox,
    InputToggleSwitch: include.InputToggleSwitch,
    InputDate: include.InputDate,
    InputOptionalDate: include.InputOptionalDate,
    InputOptionalDateFastNav: include.InputOptionalDateFastNav,
    InputDateRange: include.InputDateRange,
    CancelButton: include$1.CancelButton,
    SubmitButton: include$1.SubmitButton,
    ControlEnterKey: include$2.ControlEnterKey,
    AutoSave: include$2.AutoSave,
    useFormPropState: Core.useFormPropState,
    useField: Core.useField,
    useFormState: Core.useFormState,
    useFormDispatch: Core.useFormDispatch,
    validate: validate,
    isValidField: isValidField
  };
}

let Status;

let Submission;

export {
  Status,
  Submission,
  Make,
}
/* Form__Core Not a pure module */
